export const LOADING_DATA = 'LOADING_DATA'
export const GET_FUNERAL_DATA = 'GET_FUNERAL_DATA'
export const GET_INPROGRESS_CEREMONY_DATA = 'GET_INPROGRESS_CEREMONY_DATA'
export const GET_UPCOMING_CEREMONY_DATA = 'GET_UPCOMING_CEREMONY_DATA'
export const GET_WAITING_ROOM_DATA = 'GET_WAITING_ROOM_DATA'
export const GET_CEREMONY_ROOM_DATA = 'GET_CEREMONY_ROOM_DATA'
export const CHOOSE_RESERVATION = 'CHOOSE_RESERVATION'